/**
 * Fixed application operation labels approved for sanitized console output.
 *
 * This foundational registry is intentionally minimal. Production operations
 * are added alongside their call-site migrations so dynamic labels never enter
 * the boundary.
 */
export const SAFE_CONSOLE_OPERATIONS = Object.freeze({
  "api-error-reporting-failed": "API Error Reporting Failed",
  "api-error-handled": "API Error Handled",
  "api-request-failed": "API Request Failed",
  "api-request-unexpected-error": "API Request Failed With an Unexpected Error",
  "application-lifecycle": "Application Lifecycle Diagnostic",
  "authentication-lifecycle": "Authentication Lifecycle Diagnostic",
  "data-processing": "Data Processing Diagnostic",
  "error-boundary": "Error Boundary Diagnostic",
  "external-integration": "External Integration Diagnostic",
  "local-storage": "Local Storage Diagnostic",
  "monitoring-dashboard": "Monitoring Dashboard Diagnostic",
  "realtime-stream": "Realtime Stream Diagnostic",
  "route-loading": "Route Loading Diagnostic",
  "runtime-error": "Runtime Error",
  "service-operation": "Service Operation Diagnostic",
  "technician-deletion": "Technician Deletion Diagnostic",
  "ui-action": "User Interface Action Diagnostic",
  "unregistered-operation": "Unregistered Application Diagnostic",
  "workflow-lifecycle": "Workflow Lifecycle Diagnostic",
} as const);
